module.exports = "/packs/images/homepage/facilities/adult-swim~2d185fc69e9ff28f9b7c0643ad33c636.jpg";